import type { SignAttendanceSheetBody, SignAttendanceSheetResponse } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const signAttendanceSheet = createApiThunk<SignAttendanceSheetResponse, SignAttendanceSheetBody>(
  "trainingFollowUps/signAttendanceSheet",
  async (payload: SignAttendanceSheetBody, { extra: { studentRepository } }) => {
    return studentRepository!.signAttendanceSheet(payload);
  },
);
